import React from "react"

import Layout from "../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

import Link from "../../components/Link"
import Seo from "../../components/seo"
import Vimeo from "../../components/vimeo"

const KaffePage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  var customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")
  // override:
  customCrumbLabel = "kaffe"
  let seoImage = {
    src: "//ementodk.netlify.app/images/previews/internal_preview.jpg",
    width: 1024,
    height: 566,
  }
  return (
    <Layout location={props.location}>
      <Seo title="Emento Imagination" image={seoImage} pathname="team/kaffe" />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner default-size">
            <div className="space-8" />
            <div className="two-col gap">
              <div className="box">
                <h1>Emento Kaffen</h1>
                <p>
                  Vores egen kaffe hedder IMAGINATION fordi vi hylder
                  forestillingskraften. Desuden kan kaffe være en anledning til
                  at tage en pause, hvor tankerne kan flyde frit, ligesom kaffe
                  er en god måde at starte en dialog. Og ja ... så kan vi bare
                  virkelig godt li' kaffe 😀
                </p>
                <p>
                  Emento IMAGINATION er ansvarlig produceret. Vi forestiller os,
                  at du får en god smag i munden i mere end én forstand.
                </p>
              </div>
              <div className="box"></div>
            </div>
            <p>
              Se her, hvordan vi nørdede kaffe sammen og fandt frem til vores
              helt egen kaffeblend:
            </p>
            <div className="video-player">
              <Vimeo
                videoSrcURL="https://player.vimeo.com/video/891616408?h=7315e1a824&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479"
                videoTitle="Emento Kaffe Workshop"
                iframeStyle="video-iframe"
              />
            </div>
            <p className="credits">
              Musik: Mikkel Bech. Indspillet med Emento Preamp #0001
            </p>
            <div className="space-8" />
            <p>
              Emento IMAGINATION består af 45% <b>Rwanda Imbizi,</b> 45%{" "}
              <b>Peru</b> og 10% <b>forestillingskraft</b>.
            </p>

            <br />
            <div className="two-col gap">
              <div className="box">
                <div className="card">
                  <h3>Rwanda, Imbizi</h3>
                  <img
                    src="../../images/team/kaffe/kaffe_rwanda.jpg"
                    alt="Rwanda, Imbizi, coffee"
                  />
                  <p>
                    Imbizi kaffen produceres af kooperativet The Women Coffee
                    Extension (WCE) i Rwanda, der består af ca. 700 små lokale
                    farmere og har til mål at give de kvindelige farmere en
                    større stemme og bedre forhold.
                  </p>
                  <p>
                    WCE skaber bl.a. et fællesskab for de kvindelige farmere,
                    hvoraf mange er enker eller forældreløse efter folkedrabet i
                    1994. Kvinderne er ofte eneforsørgere for deres familier, og
                    WCE arbejder for at uddanne kvinderne for at få en bedre
                    forståelse for værdikæden i kaffebranchen, således at deres
                    egen kaffe kan blive midlet til at skabe en positiv social
                    forandring i lokalsamfundet.
                  </p>
                  <p>kilde: europakaffeogte.dk</p>
                </div>
              </div>
              <div className="box">
                <div className="card">
                  <h3>Peru</h3>
                  <img
                    src="../../images/team/kaffe/kaffe_peru.jpg"
                    alt="Peru, coffee"
                  />
                  <p>
                    Peru-kaffen stammer fra Cooperativa Agroindustrial Tropicals
                    Products Of Pichanaqui, der består af 12 kaffeproducenter
                    med det mål at øge værdien af deres produkter. Siden deres
                    opstart i 2018 har denne kooperative og solidariske
                    organisation arbejdet hårdt for at imødekomme behovene hos
                    sine 168 producent-medlemmer, som nu spreder sig over flere
                    forskellige provinser som Chanchamayo, Satipo og Oxapampa.
                  </p>
                  <p>
                    Medlemmerne arbejder nu med at producere kaffe i harmoni med
                    naturen, ved at dyrke økologisk og tage andre bæredygtige
                    tiltag for at genoprette biodiversiteten.
                  </p>
                  <p>kilde: europakaffeogte.dk</p>
                </div>
              </div>
            </div>
            <div className="two-col gap">
              <div className="box">
                <h2>
                  Emento IMAGINATION er frugtig og fyldig med en lang og
                  ansvarlig eftersmag.
                </h2>
                <p>
                  Et mangfoldigt, fyldigt og økologisk kaffeblend. Kaffen er
                  mellemristet og har en bund af kakao og nødder, balanceret med
                  noter af stenfrugt og bær - og har en lang, ansvarlig
                  eftersmag.
                </p>
                <h3>EUROPA - bæredygtig og ansvarlig kaffe</h3>
                <p>
                  Med over 70 års erfaring inden for kaffe-branchen, har EUROPA
                  styr på hele kaffeværdikæden. De har hjertet på det rette
                  sted, når de indgår samarbejde med bønder og leverandører, og
                  de tager højde for miljø og samfund under produktionen. Deres
                  vision er at gøre bæredygtigt og ansvarligt produceret
                  specialkaffe tilgængelig for så mange som muligt. I Brabrand
                  ved Aarhus åbnede EUROPA i 2019 et kafferisteri, hvor områdets
                  beboere er en del af driften.
                </p>
                <p>
                  Læs mere om EUROPA her:{" "}
                  <Link to="https://europakaffeogte.dk">
                    europakaffeogte.dk
                  </Link>
                </p>
              </div>
              <div className="box"></div>
            </div>
            <div className="space-8" />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default KaffePage
